import { JOB_TYPE_ID } from '../constants';
import { IImageAsset } from './IAsset';
import { IEntry } from './IEntry';

export enum JobType {
	FullTime = 'Full-time',
	PartTime = 'Part-time',
	Seasonal = 'Seasonal',
	Internship = 'Internship',
}

export interface IJob {
	title: string;
	slug: string;
	seoTitle?: string;
	seoDescription?: string;
	employerName: string;
	employerLogo?: IImageAsset;
	deadline?: string;
	type: string;
	hoursPerWeek?: string;
	description: string;
	applyLinkUrl: string;
	background?: IImageAsset;
	pinned?: boolean;
}

export interface IJobEntry extends IEntry<IJob, typeof JOB_TYPE_ID> {}
